/**
 * Product Catalog Management
 * ## TMF API Reference: TMF620 - Product Catalog Management  ### Release : 19.0 - June 2019  Product Catalog API is one of Catalog Management API Family. Product Catalog API goal is to provide a catalog of products.   ### Operations Product Catalog API performs the following operations on the resources : - Retrieve an entity or a collection of entities depending on filter criteria - Partial update of an entity (including updating rules) - Create an entity (including default values and creation rules) - Delete an entity - Manage notification of events
 *
 * OpenAPI spec version: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CatalogBatchEvent } from '../model/catalogBatchEvent';
import { CatalogCreateEvent } from '../model/catalogCreateEvent';
import { CatalogDeleteEvent } from '../model/catalogDeleteEvent';
import { CategoryCreateEvent } from '../model/categoryCreateEvent';
import { CategoryDeleteEvent } from '../model/categoryDeleteEvent';
import { EventSubscription } from '../model/eventSubscription';
import { ProductOfferingAttributeValueChangeEvent } from '../model/productOfferingAttributeValueChangeEvent';
import { ProductOfferingCreateEvent } from '../model/productOfferingCreateEvent';
import { ProductOfferingDeleteEvent } from '../model/productOfferingDeleteEvent';
import { ProductOfferingPriceAttributeValueChangeEvent } from '../model/productOfferingPriceAttributeValueChangeEvent';
import { ProductOfferingPriceCreateEvent } from '../model/productOfferingPriceCreateEvent';
import { ProductOfferingPriceDeleteEvent } from '../model/productOfferingPriceDeleteEvent';
import { ProductOfferingPriceStateChangeEvent } from '../model/productOfferingPriceStateChangeEvent';
import { ProductOfferingStateChangeEvent } from '../model/productOfferingStateChangeEvent';
import { ProductSpecificationCreateEvent } from '../model/productSpecificationCreateEvent';
import { ProductSpecificationDeleteEvent } from '../model/productSpecificationDeleteEvent';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class NotificationListenersClientSideService {

    protected basePath = 'https://serverRoot/tmf-api/productCatalogManagement/v4/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Client listener for entity CatalogBatchEvent
     * Example of a client listener for receiving the notification CatalogBatchEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToCatalogBatchEvent(data: CatalogBatchEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToCatalogBatchEvent(data: CatalogBatchEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToCatalogBatchEvent(data: CatalogBatchEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToCatalogBatchEvent(data: CatalogBatchEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToCatalogBatchEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/catalogBatchEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity CatalogCreateEvent
     * Example of a client listener for receiving the notification CatalogCreateEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToCatalogCreateEvent(data: CatalogCreateEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToCatalogCreateEvent(data: CatalogCreateEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToCatalogCreateEvent(data: CatalogCreateEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToCatalogCreateEvent(data: CatalogCreateEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToCatalogCreateEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/catalogCreateEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity CatalogDeleteEvent
     * Example of a client listener for receiving the notification CatalogDeleteEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToCatalogDeleteEvent(data: CatalogDeleteEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToCatalogDeleteEvent(data: CatalogDeleteEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToCatalogDeleteEvent(data: CatalogDeleteEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToCatalogDeleteEvent(data: CatalogDeleteEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToCatalogDeleteEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/catalogDeleteEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity CategoryCreateEvent
     * Example of a client listener for receiving the notification CategoryCreateEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToCategoryCreateEvent(data: CategoryCreateEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToCategoryCreateEvent(data: CategoryCreateEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToCategoryCreateEvent(data: CategoryCreateEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToCategoryCreateEvent(data: CategoryCreateEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToCategoryCreateEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/categoryCreateEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity CategoryDeleteEvent
     * Example of a client listener for receiving the notification CategoryDeleteEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToCategoryDeleteEvent(data: CategoryDeleteEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToCategoryDeleteEvent(data: CategoryDeleteEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToCategoryDeleteEvent(data: CategoryDeleteEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToCategoryDeleteEvent(data: CategoryDeleteEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToCategoryDeleteEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/categoryDeleteEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductOfferingAttributeValueChangeEvent
     * Example of a client listener for receiving the notification ProductOfferingAttributeValueChangeEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductOfferingAttributeValueChangeEvent(data: ProductOfferingAttributeValueChangeEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductOfferingAttributeValueChangeEvent(data: ProductOfferingAttributeValueChangeEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductOfferingAttributeValueChangeEvent(data: ProductOfferingAttributeValueChangeEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductOfferingAttributeValueChangeEvent(data: ProductOfferingAttributeValueChangeEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductOfferingAttributeValueChangeEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productOfferingAttributeValueChangeEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductOfferingCreateEvent
     * Example of a client listener for receiving the notification ProductOfferingCreateEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductOfferingCreateEvent(data: ProductOfferingCreateEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductOfferingCreateEvent(data: ProductOfferingCreateEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductOfferingCreateEvent(data: ProductOfferingCreateEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductOfferingCreateEvent(data: ProductOfferingCreateEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductOfferingCreateEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productOfferingCreateEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductOfferingDeleteEvent
     * Example of a client listener for receiving the notification ProductOfferingDeleteEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductOfferingDeleteEvent(data: ProductOfferingDeleteEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductOfferingDeleteEvent(data: ProductOfferingDeleteEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductOfferingDeleteEvent(data: ProductOfferingDeleteEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductOfferingDeleteEvent(data: ProductOfferingDeleteEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductOfferingDeleteEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productOfferingDeleteEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductOfferingPriceAttributeValueChangeEvent
     * Example of a client listener for receiving the notification ProductOfferingPriceAttributeValueChangeEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductOfferingPriceAttributeValueChangeEvent(data: ProductOfferingPriceAttributeValueChangeEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductOfferingPriceAttributeValueChangeEvent(data: ProductOfferingPriceAttributeValueChangeEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductOfferingPriceAttributeValueChangeEvent(data: ProductOfferingPriceAttributeValueChangeEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductOfferingPriceAttributeValueChangeEvent(data: ProductOfferingPriceAttributeValueChangeEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductOfferingPriceAttributeValueChangeEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productOfferingPriceAttributeValueChangeEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductOfferingPriceCreateEvent
     * Example of a client listener for receiving the notification ProductOfferingPriceCreateEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductOfferingPriceCreateEvent(data: ProductOfferingPriceCreateEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductOfferingPriceCreateEvent(data: ProductOfferingPriceCreateEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductOfferingPriceCreateEvent(data: ProductOfferingPriceCreateEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductOfferingPriceCreateEvent(data: ProductOfferingPriceCreateEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductOfferingPriceCreateEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productOfferingPriceCreateEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductOfferingPriceDeleteEvent
     * Example of a client listener for receiving the notification ProductOfferingPriceDeleteEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductOfferingPriceDeleteEvent(data: ProductOfferingPriceDeleteEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductOfferingPriceDeleteEvent(data: ProductOfferingPriceDeleteEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductOfferingPriceDeleteEvent(data: ProductOfferingPriceDeleteEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductOfferingPriceDeleteEvent(data: ProductOfferingPriceDeleteEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductOfferingPriceDeleteEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productOfferingPriceDeleteEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductOfferingPriceStateChangeEvent
     * Example of a client listener for receiving the notification ProductOfferingPriceStateChangeEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductOfferingPriceStateChangeEvent(data: ProductOfferingPriceStateChangeEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductOfferingPriceStateChangeEvent(data: ProductOfferingPriceStateChangeEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductOfferingPriceStateChangeEvent(data: ProductOfferingPriceStateChangeEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductOfferingPriceStateChangeEvent(data: ProductOfferingPriceStateChangeEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductOfferingPriceStateChangeEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productOfferingPriceStateChangeEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductOfferingStateChangeEvent
     * Example of a client listener for receiving the notification ProductOfferingStateChangeEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductOfferingStateChangeEvent(data: ProductOfferingStateChangeEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductOfferingStateChangeEvent(data: ProductOfferingStateChangeEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductOfferingStateChangeEvent(data: ProductOfferingStateChangeEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductOfferingStateChangeEvent(data: ProductOfferingStateChangeEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductOfferingStateChangeEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productOfferingStateChangeEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductSpecificationCreateEvent
     * Example of a client listener for receiving the notification ProductSpecificationCreateEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductSpecificationCreateEvent(data: ProductSpecificationCreateEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductSpecificationCreateEvent(data: ProductSpecificationCreateEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductSpecificationCreateEvent(data: ProductSpecificationCreateEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductSpecificationCreateEvent(data: ProductSpecificationCreateEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductSpecificationCreateEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productSpecificationCreateEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Client listener for entity ProductSpecificationDeleteEvent
     * Example of a client listener for receiving the notification ProductSpecificationDeleteEvent
     * @param data The event data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listenToProductSpecificationDeleteEvent(data: ProductSpecificationDeleteEvent, observe?: 'body', reportProgress?: boolean): Observable<EventSubscription>;
    public listenToProductSpecificationDeleteEvent(data: ProductSpecificationDeleteEvent, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventSubscription>>;
    public listenToProductSpecificationDeleteEvent(data: ProductSpecificationDeleteEvent, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventSubscription>>;
    public listenToProductSpecificationDeleteEvent(data: ProductSpecificationDeleteEvent, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling listenToProductSpecificationDeleteEvent.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=utf-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EventSubscription>(`${this.basePath}/listener/productSpecificationDeleteEvent`,
            data,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
